import React, { useEffect, useState } from 'react';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import classes from './styles/ToggleCollapseExpand.module.scss';

export const ToggleCollapseExpand = ({
  isExpanded: expandedFromProps,
  onToggle
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = (e) => {
    if (onToggle) {
      onToggle(e); // Notify parent of the new state
    } else {
      setIsExpanded((prev) => {
        const newState = !prev;

        return newState;
      });
    }
  };

  useEffect(() => {
    if (expandedFromProps !== isExpanded) {
      setIsExpanded(expandedFromProps);
    }
  }, [expandedFromProps]);

  return (
    <button className={classes.toggleButton} onClick={toggle}>
      <span
        className={`${classes.iconWrapper} ${
          isExpanded ? classes.expanded : classes.collapsed
        }`}
      >
        {isExpanded ? <MinusOutlined /> : <PlusOutlined />}
      </span>
    </button>
  );
};
